module.exports = __webpack_public_path__ + "static/media/FeedBackIcon.9b57b425.svg";